<script setup>
import { nextTick, ref, watch } from "vue";
// import { defineModel } from "vue";
import { useCountryStore } from "@/stores/countries";
const modelValue = defineModel();
const store = useCountryStore();

if (store.getCountries.length == 0) {
  store.fetchCountries();
}
const emit = defineEmits(["update:country", "update:state", "update:city"]);

const props = defineProps({
  country: [String, Number, Array],
  state: [String, Number],
  city: [String, Number],
  gridType: {
    type: String,
    default: "inline",
  },
  multiSelect: {
    type: Boolean,
    default: false,
  },
  col: {
    type: String,
    default: "4",
  },
  showInput: {
    type: Array,
    default: ["state", "city"],
  },
  class: {
    type: String,
    default: "w-full",
  },
});

const countryId = ref(props.country ?? "");
const stateId = ref(props.state ?? "");
const cityId = ref(props.city ?? "");

const clearable = () => {
  countryId.value = "";
  stateId.value = "";
};
const clearableState = () => (stateId.value = "");
const fetchStates = async () => {
  if (props.showInput.includes("state")) {
    await store.fetchState(countryId.value);
  }
};
const fetchCity = async () => {
  if (props.showInput.includes("city")) {
    await store.fetchCities(stateId.value);
  }
};

if (countryId.value != "" && countryId.value != null) {
  fetchStates();
}
if (stateId.value != "" && stateId.value != null) {
  fetchCity();
}
watch(
  () => props.country,
  () => {
    countryId.value = props.country;
  },
  {
    deep: true,
  }
);
watch(
  () => props.state,
  () => {
    stateId.value = props.state;
  },
  {
    deep: true,
  }
);
watch(
  () => props.city,
  () => {
    cityId.value = props.city;
  },
  {
    deep: true,
  }
);

watch(
  countryId,
  (newValue, OldValue) => {
    emit("update:country", countryId.value);

    if (countryId.value == null || countryId.value == "") {
      store.states = [];
    } else {
      fetchStates();
    }
    if (OldValue != "") {
      stateId.value = "";
      cityId.value = "";
    }
  },
  {
    deep: true,
  }
);

watch(
  stateId,
  () => {
    emit("update:state", stateId.value);

    if (stateId.value == null || stateId.value == "") {
      store.cities = [];
    } else {
      fetchCity();
    }
  },
  {
    deep: true,
  }
);
watch(
  cityId,
  () => {
    emit("update:city", cityId.value);
  },
  {
    deep: true,
  }
);
</script>
<template>
  <v-autocomplete
    v-if="is_enabled_module('country')"
    :menu-props="{ maxHeight: 500 }"
    :loading="store.LoadingCountry"
    :multiple="multiSelect"
    hide-no-data
    autocomplete="off"
    @click:clear="clearable"
    clearable
    v-model="countryId"
    :items="store.getCountries"
    class="h-12 border-gray-300 rounded-lg shadow-sm focus:border-primary focus:border-2 focus:ring-primary focus:ring-opacity-50"
    item-value="id"
    item-title="name"
    :label="__t('country')"
    :class="props.class"
  >
  </v-autocomplete>
</template>
